import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Breadcrumb = ({ items, className = '', variant = 'dark' }) => {
  if (!items || items.length === 0) return null;

  const isLight = variant === 'light';
  const mutedText = isLight ? 'text-[#323639]/50' : 'text-[#FFFFFF]/60';
  const chevronText = isLight ? 'text-[#323639]/30' : 'text-[#FFFFFF]/30';
  const currentText = isLight ? 'text-[#323639]/90' : 'text-[#FFFFFF]/90';
  const linkText = isLight ? 'text-[#323639]/60' : 'text-[#FFFFFF]/60';

  const breadcrumbs = items.map((item, index) => ({
    label: item.label,
    href: item.href,
    isLast: index === items.length - 1
  }));

  return (
    <>
      <Helmet>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs.map((crumb, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: crumb.label,
                item: crumb.href ? `https://dopove.com${crumb.href}` : undefined
              })).filter(c => c.item)
            })
          }}
        />
      </Helmet>

      <nav
        className={`flex items-center gap-2 text-sm ${mutedText} ${className}`}
        aria-label="Breadcrumb"
      >
        <ol className="flex items-center gap-2">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.href || crumb.label} className="flex items-center gap-2">
              {index > 0 && (
                <span className={chevronText} aria-hidden="true">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </span>
              )}
              {crumb.isLast ? (
                <span
                  className={`${currentText} font-medium`}
                  aria-current="page"
                >
                  {crumb.label}
                </span>
              ) : (
                <Link
                  to={crumb.href}
                  className={`${linkText} hover:text-[#6FB6E8] transition-colors duration-200 ease-[var(--ease-out)]`}
                >
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumb;